import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  name: 'Martina',
  text: 'Pensé que serían casos muy fáciles, pero algunos realmente me hicieron pensar. Me encantó poder imprimirlos y resolverlos con lápiz.'
}, {
  name: 'Tomás',
  text: 'Compré el pack por el primer libro y terminé disfrutando todavía más Viaje al Pasado. Son muchos acertijos y todos tienen escenarios diferentes.'
}, {
  name: 'Sofía',
  text: 'Está buenísimo para hacer en pareja. Nosotros competimos para ver quién descubre primero al culpable.'
}, {
  name: 'Julián',
  text: 'Excelente forma de desconectar del celular. Los casos te atrapan desde el principio y la dificultad va subiendo perfecto.'
}, {
  name: 'Camila',
  text: 'Me encantó la estética y cómo están planteados los acertijos. El de Viaje al Pasado tiene escenarios increíbles.'
}, {
  name: 'Lucas',
  text: 'Muy buen precio por la cantidad de horas de entretenimiento que te da. Las soluciones al final son clave para no quedarse trabado.'
}];
export const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <div className="relative max-w-4xl mx-auto px-12" data-id="element-163" data-mp="2lb3kp1cq4fr6">
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-lg text-murdoku-purple hover:bg-murdoku-orange hover:text-white transition-colors z-10" data-id="element-164" data-mp="2l8h6iivbv1zz">
        <ChevronLeft size={24} data-id="element-165" data-mp="26dkoxf1mp2a8" />
      </button>

      <div className="overflow-hidden py-4" data-id="element-166" data-mp="26emaidg9t767">
        <AnimatePresence mode="wait" data-id="element-167" data-mp="26fxhem50iv1j">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border-t-4 border-murdoku-orange" data-id="element-168" data-mp="9lj6mfmpku3o">
            <div className="flex flex-col items-center text-center mb-6" data-id="element-169" data-mp="23uy4d6tyw2zo">
              <div className="flex text-murdoku-orange mb-4" data-id="element-170" data-mp="1p61xhd3ncw0n">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-171" data-mp="1u3v0xydkfbx8" data-mpi={i} />)}
              </div>
              <p className="text-gray-800 md:text-2xl font-medium mb-6 text-[16px]" data-id="element-172" data-mp="2htxsmddkifvb">
                "{testimonials[currentIndex].text}"
              </p>
              <div className="w-12 h-12 bg-murdoku-cream rounded-full flex items-center justify-center text-murdoku-purple font-bold text-xl border-2 border-murdoku-purple/10" data-id="element-173" data-mp="28s81z9rifkyl">
                {testimonials[currentIndex].name.charAt(0)}
              </div>
              <h4 className="font-heading font-bold text-xl text-murdoku-dark mt-2 tracking-wide" data-id="element-174" data-mp="xbhpj8whtwwj">
                {testimonials[currentIndex].name}
              </h4>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-lg text-murdoku-purple hover:bg-murdoku-orange hover:text-white transition-colors z-10" data-id="element-175" data-mp="ow28is27hsni">
        <ChevronRight size={24} data-id="element-176" data-mp="yuhpw3bflnjt" />
      </button>

      <div className="flex justify-center gap-3 mt-8" data-id="element-177" data-mp="yurhfvc4k2rm">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-colors ${idx === currentIndex ? 'bg-murdoku-orange' : 'bg-gray-300'}`} data-id="element-178" data-mp="b5oy8j1ue1v0" data-mpi={idx} />)}
      </div>
    </div>;
};